import React from "react";
import ModalLayout from "../../ModalLayout";
import { ExitModalStyled } from "./style";
import Button from "../../Ui/Button";
var ExitModal = function (_a) {
    var onExit = _a.onExit, onClick = _a.onClick;
    return (React.createElement(ModalLayout, { onExit: onExit },
        React.createElement(ExitModalStyled, null,
            React.createElement("h2", null, "\u00BFDeseas abandonar el sitio?"),
            React.createElement("p", null, "Recuerda pagar tu factura a tiempo para que sigas disfrutando de tu plan pospago en la \u00FAnica red 100% 4G."),
            React.createElement("div", { className: "button-container-exitmodal" },
                React.createElement(Button, { minWidth: 190, line: true, onClick: onClick }, "ABANDONAR"),
                React.createElement(Button, { minWidth: 190, onClick: onExit }, "CANCELAR")))));
};
export default React.memo(ExitModal);
